import { useState } from 'react';
import { useAssessmentsListQuery } from '@common/cache';
import {
  IAssessmentsTableEntry,
  IAssessmentsTableFilters,
} from '../components/AssessmentsTable/hooks';
import { isEqual } from 'lodash';

const initialFilter: IAssessmentsTableFilters = {
  sort_order: 'desc',
  sort_by: 'date',
  page: 1,
  limit: 100,
  type: '',
  completed: '',
  date: '',
};

export const useAssessments = (patient_id: string) => {
  const [itemEditId, setItemEditId] = useState<string>('');
  const [filters, setFilters] = useState<IAssessmentsTableFilters>({
    ...initialFilter,
  });

  const isInitialFilters = isEqual(filters, initialFilter);

  const {
    data = { assessments: [], count: 0 },
    isFetching,
    isRefetching,
  } = useAssessmentsListQuery({
    patient_id,
    page: filters.page,
    limit: filters.limit,
    sort_order: filters.sort_order,
    sort_by: filters.sort_by,
    date: filters.date,
    type: filters.type,
    ...(filters.completed && {
      completed: filters.completed === 'true',
    }),
  });

  const entries: IAssessmentsTableEntry[] = data.assessments.map(
    assessment => ({
      id: assessment.id,
      name: assessment.name,
      type: assessment.type,
      date: assessment.assessmentDate,
      completed: assessment.completed,
      leadingAnswers: assessment.leadingAnswers,
      answerGroups: assessment.answerGroups,
      assessingProvider: assessment.assessingProvider,
    }),
  );

  const handleCloseEditModal = () => {
    setItemEditId('');
  };

  const handleResetFilter = () => {
    setFilters(initialFilter);
  };

  return {
    isInitialFilters,
    entries,
    totalCount: data.count,
    filters,
    setFilters,
    isLoading: isFetching || isRefetching,
    itemEditId,
    setItemEditId,
    handleCloseEditModal,
    handleResetFilter,
    isFilterDisabled: isEqual(filters, initialFilter),
  };
};
